import { api } from "../../../../app/api";
import { Options } from "../../../../common/types/requestOptions";

export interface DateRange {
  id?: string;
  start: string; // LocalDate as ISO string
  end: string; // LocalDate as ISO string
}

export interface DeletePaymentProhibition {
  id: string;
  version: number;
}

export interface TalentPaymentProhibitionCancelDetails {
  id: string;
  version: number;
  end?: string;
  type: string;
}

export interface TalentPaymentProhibition {
  id: string;
  version: number;
  talentId: string;
  rfReference: string;
  employer: string;
  employerName: string;
  start: string;
  enforcementAgency: string;
  deductionType: number;
  iban: string;
  bic: string;
  deductionTypeAmount?: string;
  end?: string;
  freeMonths?: DateRange[];
  garnishmentRestrictions?: GarnishmentRestriction[];
  externalMonthlyNetIncome?: string;
  dailyProtectedPortion?: string;
  additionalDeduction?: string;
  type: string;
}

// Create version of TalentPaymentProhibition where id is removed
export type TalentPaymentProhibitionCreate = Omit<
  TalentPaymentProhibition,
  "id"
>;

export interface GarnishmentRestriction {
  id?: string;
  start: string;
  end: string;
  amount: string;
}

export const getTalentPaymentProhibitions = (
  talentId: string,
  { requestId }: Options,
) => {
  return api.get<TalentPaymentProhibition[]>(
    "/projections/qry/talentPaymentProhibitions",
    {
      requestId,
      queryParams: {
        talentId: talentId,
      },
      auth: true,
    },
  );
};

export const postCreatePaymentProhibition = (
  paymentProhibition: TalentPaymentProhibition,
  { requestId }: Options,
) => {
  // Destructure `id` out of the object and spread the rest into `bodyWithoutId`
  const { id, ...bodyWithoutId } = paymentProhibition;
  return api.post<any>("/invoicing/cmd/createTalentPaymentProhibition", {
    requestId,
    body: {
      ...bodyWithoutId,
    },
    auth: true,
  });
};

export const postUpdatePaymentProhibition = (
  paymentProhibition: TalentPaymentProhibition,
  { requestId }: Options,
) => {
  return api.post<any>("/invoicing/cmd/updateTalentPaymentProhibition", {
    requestId,
    body: {
      ...paymentProhibition,
    },
    auth: true,
  });
};

export const postUpdatePaymentProhibitionCancelDetails = (
  paymentProhibition: TalentPaymentProhibitionCancelDetails,
  { requestId }: Options,
) => {
  return api.post<any>(
    "/invoicing/cmd/updateTalentPaymentProhibitionCancelDetails",
    {
      requestId,
      body: {
        ...paymentProhibition,
      },
      auth: true,
    },
  );
};

export const postDeletePaymentProhibition = (
  deletePaymentProhibition: DeletePaymentProhibition,
  { requestId }: Options,
) => {
  return api.post<any>("/invoicing/cmd/deleteTalentPaymentProhibition", {
    requestId,
    body: {
      id: deletePaymentProhibition.id,
      version: deletePaymentProhibition.version,
    },
    auth: true,
  });
};
